/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeMutedContactsResponse,
  MuteContactRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type msgContactMuteGetMutedContactsResponse200 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 200
}

export type msgContactMuteGetMutedContactsResponse401 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 401
}

export type msgContactMuteGetMutedContactsResponseSuccess = (msgContactMuteGetMutedContactsResponse200) & {
  headers: Headers;
};
export type msgContactMuteGetMutedContactsResponseError = (msgContactMuteGetMutedContactsResponse401) & {
  headers: Headers;
};

export type msgContactMuteGetMutedContactsResponse = (msgContactMuteGetMutedContactsResponseSuccess | msgContactMuteGetMutedContactsResponseError)

export const getMsgContactMuteGetMutedContactsUrl = () => {




  return `/api/msgs/muted-contacts`
}

export const useMsgContactMuteGetMutedContactsHook = (): ( options?: RequestInit) => Promise<msgContactMuteGetMutedContactsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getMsgContactMuteGetMutedContactsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type msgContactMuteMuteContactResponse200 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 200
}

export type msgContactMuteMuteContactResponse400 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 400
}

export type msgContactMuteMuteContactResponse401 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 401
}

export type msgContactMuteMuteContactResponseSuccess = (msgContactMuteMuteContactResponse200) & {
  headers: Headers;
};
export type msgContactMuteMuteContactResponseError = (msgContactMuteMuteContactResponse400 | msgContactMuteMuteContactResponse401) & {
  headers: Headers;
};

export type msgContactMuteMuteContactResponse = (msgContactMuteMuteContactResponseSuccess | msgContactMuteMuteContactResponseError)

export const getMsgContactMuteMuteContactUrl = () => {




  return `/api/msgs/muted-contacts`
}

export const useMsgContactMuteMuteContactHook = (): (muteContactRequest?: MuteContactRequest, options?: RequestInit) => Promise<msgContactMuteMuteContactResponse> => {

      const customFetcher = useSfetchMutator();
      return (muteContactRequest?: MuteContactRequest, options?: RequestInit) => {

        return customFetcher(getMsgContactMuteMuteContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(muteContactRequest)
  }
);
      }
  }


export type msgContactMuteUnmuteContactResponse200 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 200
}

export type msgContactMuteUnmuteContactResponse401 = {
  data: ApiEnvelopeMutedContactsResponse
  status: 401
}

export type msgContactMuteUnmuteContactResponseSuccess = (msgContactMuteUnmuteContactResponse200) & {
  headers: Headers;
};
export type msgContactMuteUnmuteContactResponseError = (msgContactMuteUnmuteContactResponse401) & {
  headers: Headers;
};

export type msgContactMuteUnmuteContactResponse = (msgContactMuteUnmuteContactResponseSuccess | msgContactMuteUnmuteContactResponseError)

export const getMsgContactMuteUnmuteContactUrl = (name: string,) => {




  return `/api/msgs/muted-contacts/${name}`
}

export const useMsgContactMuteUnmuteContactHook = (): (name: string, options?: RequestInit) => Promise<msgContactMuteUnmuteContactResponse> => {

      const customFetcher = useSfetchMutator();
      return (name: string, options?: RequestInit) => {

        return customFetcher(getMsgContactMuteUnmuteContactUrl(name),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


